<div class="loaderwrapper" *ngIf="this.loader">
  <span class="loader"></span>
</div>

<!-- Add Button and Selected Plants -->
<section class="dashboard-main container-fluid">
  <section class="contents-main">
    <div class="container-fluid">
      <div class="card table-card">
          <!-- Title, filters and the page actions share one row at the top
               of the card rather than stacking above it. -->
          <div class="table-toolbar">
              <h1 class="table-toolbar__title">Users</h1>
              <div class="sb-filter-holder sb-filter-holder--inline">
                  <!-- Type Filter -->
                  <div class="input-wrapper">
                    <ng-select [(ngModel)]="filterUserType" (change)="selectTypelistStatus($event)" placeholder="User Type"
                      class="sb-filter-field sb-filter-field--md">
                      <ng-option *ngFor="let Item of userTypelist" [value]="Item.id">{{Item.name}}</ng-option>
                    </ng-select>
                  </div>
                  <!-- Role Filter -->
                  <div class="input-wrapper">
                    <ng-select (change)="selectRoleslistStatus($event)" placeholder="Role"
                      class="sb-filter-field sb-filter-field--md" disabled="!filterUserType">
                      <ng-option *ngFor="let Item of filterRolesList" [value]="Item.id">{{Item.name}}</ng-option>
                    </ng-select>
                  </div>
                  <!-- Status Filter -->
                  <div class="input-wrapper">
                    <ng-select (change)="selecttStatus($event)" placeholder="Status" class="sb-filter-field sb-filter-field--md">
                      <ng-option *ngFor="let Item of statusList" [value]="Item.id">{{Item.name}}</ng-option>
                    </ng-select>
                  </div>
                  <div class="btn-group sb-filter-search-group" role="group">
                    <input type="text" class="sb-filter-field sb-filter-search-input" placeholder="Search"
                      (input)="searchData($event)">
                    <button type="button" class="btn sb-filter-search-btn">
                      <!-- <i class="ri-search-line"></i> -->
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M17.5 17.5L13.875 13.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </button>
                  </div>
              </div>
              <button type="button" class="btn btn-dark rounded" (click)="addUser(user)"
                *ngIf="permissionsReady && permissions.canAdd">Add User</button>
              <button type="button" class="btn btn-dark rounded" (click)="downloadReport()"
                *ngIf="permissionsReady && permissions.canView">
                <ng-container *ngIf="!isDownloading; else downloading">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" class="me-2">
                    <path d="M10 1.5V14.5L14 10.1667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M10 14.5L5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M1 18.5H19" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  Export User Details
                </ng-container>
                <ng-template #downloading>
                  <span class="spinner-border spinner-border-sm me-2"></span> Exporting...
                </ng-template>
              </button>
          </div>
          <div class="table-wrap" [class.is-loading]="tableLoader">
              <div class="loaderwrapper" *ngIf="tableLoader">
                  <span class="loader"></span>
              </div>
            <ngx-datatable #myTable [style.width]="'100%'" class="material expandable table-responsive" [rows]="row"
              [headerHeight]="50" [footerHeight]="0" [columnMode]="'force'" [scrollbarH]="true" [rowHeight]="'auto'"
              [externalSorting]="true" [messages]="{emptyMessage: 'No User found.'}" (sort)="onSort($event)"
              *ngIf="permissionsReady && permissions.canView">
              <ngx-datatable-row-detail [rowHeight]="0" #myDetailRow (toggle)="onDetailToggle(row)">
                <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
                </ng-template>
              </ngx-datatable-row-detail>

              <ngx-datatable-column [sortable]="false" name="Sr. No" prop="user_id" [width]="80" [maxWidth]="80"
                [flexGrow]="0">
                <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                  <div class="form-group" style="margin-bottom: 0px"></div>
                  <span>{{ row.srNo }}</span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [sortable]="false" name="User ID" prop="user_id" [width]="80" [maxWidth]="80"
                [flexGrow]="0">
                <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                  <div class="form-group" style="margin-bottom: 0px"></div>
                  <span>{{ row.user_id }}</span>
                </ng-template>
              </ngx-datatable-column>

              <!-- <ngx-datatable-column   [sortable]="true" [minWidth]="'17%'" prop="complaintNo"
                name="Name">
                <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row" let-value="row.priorityID">
                  <div class="form-group" style="margin-bottom: 0px"></div>
                  <span>
                    {{ row.username }}
                  </span>
                </ng-template>
              </ngx-datatable-column> -->
              <ngx-datatable-column [sortable]="false" [minWidth]="'17%'" prop="complaintNo" name="Username">
                <ng-template ngx-datatable-header-template let-column="column">
                  <a class="cursor-pointer" (click)="sortUsers('username')">
                    Username
                    <span class="sort-btn" [ngClass]="{'datatable-icon-sort-unset': sortColumn !== 'username',
                                      'datatable-icon-up': sortColumn === 'username' && sortOrder === 'asc',
                                      'datatable-icon-down': sortColumn === 'username' && sortOrder === 'desc'}">
                    </span>
                  </a>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div class="form-group" style="margin-bottom: 0px"></div>
                  <span>{{ row.username }}</span>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column [sortable]="false" [minWidth]="'17%'" prop="department" name="Email">
                <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row" let-value="row.priorityID">
                  <div class="form-group" style="margin-bottom: 0px"></div>
                  <span>
                    {{ row.email }}
                  </span>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column [sortable]="false" [minWidth]="'17%'" prop="role" name="User Type">
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                  {{row.user_type}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column [sortable]="false" [minWidth]="'17%'" prop="role" name="Role">
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                  {{row.role}}
                  <!-- <span class="badge badge-custom badge-yellow badge-sm" style="font-size: 8px; padding: 5px 13px"
                    *ngIf="row.role === 'Superuser'">{{ row.role }}</span>
                  <span class="badge badge-custom badge-blue badge-sm" style="font-size: 8px; padding: 5px 13px"
                    *ngIf="row.role === 'Customer'">{{ row.role }}</span>
                  <span class="badge badge-custom badge-cyan badge-sm" style="font-size: 8px; padding: 5px 13px"
                    *ngIf="row.role === 'NOC User'">{{ row.role }}</span> -->
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column [sortable]="false" [minWidth]="'17%'" prop="assignedTo" name="Created at">
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                  {{ row.created_at | date: 'short' }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column [sortable]="false" [minWidth]="'17%'" prop="requestType" name="Status">
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                  <span class="badge badge-custom badge-success badge-sm" style="font-size: 8px; padding: 5px 13px"
                    *ngIf="row.is_active === true">Active</span>
                  <span class="badge badge-custom badge-danger badge-sm" *ngIf="row.is_active === false"
                    style="font-size: 8px; padding: 5px 13px">InActive</span>
                </ng-template>
              </ngx-datatable-column>


              <ngx-datatable-column name="Action" [sortable]="false" [resizeable]="true" [minWidth]="'5%'"
                *ngIf="hasAnyActionPermission">
                <ng-template let-row="row" ngx-datatable-cell-template>

                  <td>
                    <ul class="list-inline hstack gap-2 mb-0">
                      <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top"
                        title="View" *ngIf="permissionsReady && permissions.canView">
                        <!-- showLink(link, row) -->
                        <a (click)="view(userView, row)" data-bs-toggle="modal" title="View"
                          class="text-primary d-inline-block">
                          <!-- <i class="ri-eye-fill fs-16"></i> -->
                          <svg xmlns="http://www.w3.org/2000/svg" width="21.841" height="14.56" viewBox="0 0 21.841 14.56">
                            <g id="eye" transform="translate(-1.498 -9)">
                              <circle id="Ellipse_1436" data-name="Ellipse 1436" cx="3.105" cy="3.105" r="3.105"
                                transform="translate(9.315 13.175)" fill="currentColor" />
                              <path id="Path_5515" data-name="Path 5515"
                                d="M23.1,15.488a15.422,15.422,0,0,0-4.517-4.574A11.43,11.43,0,0,0,12.4,9a10.9,10.9,0,0,0-5.654,1.643,16.574,16.574,0,0,0-4.991,4.826,1.452,1.452,0,0,0-.029,1.617A15.2,15.2,0,0,0,6.2,21.666a11.271,11.271,0,0,0,6.2,1.894,11.478,11.478,0,0,0,6.2-1.9,15.2,15.2,0,0,0,4.508-4.592,1.465,1.465,0,0,0,0-1.582Zm-10.685,5.16a4.368,4.368,0,1,1,4.368-4.368,4.368,4.368,0,0,1-4.368,4.368Z"
                                fill="currentColor" />
                            </g>
                          </svg>
                        </a>
                      </li>
                      <li class="list-inline-item edit" data-bs-toggle="tooltip" data-bs-trigger="hover"
                        data-bs-placement="top" title="Edit" *ngIf="permissionsReady && permissions.canEdit">
                        <!-- content -->
                        <!-- userEdit -->
                        <a title="Edit" (click)="open(userEdit, row)" data-bs-toggle="modal"
                          class="text-primary d-inline-block edit-item-btn">
                          <!-- <i class="ri-pencil-fill fs-16"></i> -->
                          <svg xmlns="http://www.w3.org/2000/svg" width="14.433" height="18" viewBox="8 4 14.433 18">
                            <path
                              d="M8.9 20.2h12.6a.9.9 0 0 1 0 1.8H8.9a.9.9 0 1 1 0-1.8ZM8 15.7l9-9 2.7 2.7-9 9H8v-2.7Zm9.9-9.9L19.7 4l2.7 2.7-1.8 1.8-2.7-2.7Z"
                              fill="currentColor" />
                          </svg>
                        </a>
                      </li>

                      <!-- disableUser(row.user_id) -->
                      <!-- openDelModal(row.user_id,modalDelete) -->
                      <!-- <i class=" ri-close-circle-line  "></i>  -->
                      <!-- <li class="list-inline-item delete" data-bs-toggle="tooltip" data-bs-trigger="hover"
                        data-bs-placement="top" title="Delete" (click)="disableUser(row.user_id)">
                        <a title="Delete User" data-bs-toggle="modal" class="text-primary d-inline-block edit-item-btn">
                          <svg xmlns="http://www.w3.org/2000/svg" width="15.017" height="18" viewBox="9 6 15.017 18">
                            <path
                              d="M10.5 22.004c0 1.098.9 1.996 2 1.996h8c1.1 0 2-.898 2-1.996V10.5h-12v11.504ZM24 7.5h-3.75L18.994 6h-4.988L12.75 7.5H9V9h15V7.5Z"
                              fill="currentColor" />
                          </svg>
                        </a>
                      </li> -->
                      <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top"
                        title="Reset Password" (click)="resetPassword(row.email,modalReset)"
                        *ngIf="permissionsReady && permissions.canEdit">
                        <a title="Reset Password" data-bs-toggle="modal" class="text-primary d-inline-block edit-item-btn">
                          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19" fill="none">
                            <path
                              d="M3.84558 9.10453V5.50453C3.84446 4.38858 4.25804 3.31201 5.00602 2.48383C5.754 1.65565 6.78303 1.13495 7.89334 1.02279C9.00364 0.910641 10.116 1.21505 11.0145 1.87691C11.913 2.53878 12.5335 3.51089 12.7556 4.60453"
                              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M14.646 9.1001C15.6399 9.10031 16.4457 9.90601 16.4458 10.8999V17.1997C16.4458 18.1937 15.6399 19.0003 14.646 19.0005H2.04541C1.05139 19.0004 0.245605 18.1938 0.245605 17.1997V10.8999C0.245711 9.90594 1.05145 9.1002 2.04541 9.1001H14.646ZM8.34814 12.1499C7.47044 12.1516 6.74868 12.818 6.66162 13.6724L6.65283 13.8452C6.65147 14.4427 6.96092 14.9672 7.42529 15.27V16.4019C7.42668 16.4946 7.45562 16.5856 7.4917 16.6577C7.51866 16.7116 7.55699 16.7698 7.60693 16.8198L7.66162 16.8667L7.99561 17.1196L7.99854 17.1226C8.1043 17.2 8.2322 17.2326 8.34912 17.2329C8.4661 17.2331 8.59565 17.2005 8.70264 17.1196L9.03564 16.8657L9.03662 16.8667C9.11153 16.8108 9.16813 16.7338 9.20557 16.6606C9.24225 16.5887 9.27247 16.496 9.27197 16.3989V15.269C9.73769 14.9678 10.0467 14.4431 10.0483 13.8472V13.8452C10.0479 12.9097 9.28526 12.1483 8.34814 12.1499ZM8.3501 12.6499C8.96896 12.6492 9.48067 13.1211 9.54248 13.7231L9.54834 13.8452C9.54712 14.3051 9.28758 14.7059 8.90771 14.9048C8.8461 14.937 8.80218 14.9931 8.78369 15.0581L8.77393 15.1255L8.77197 16.3979V16.4019C8.77178 16.4028 8.77142 16.4041 8.771 16.4058C8.7691 16.4128 8.7654 16.423 8.76025 16.4331C8.7552 16.443 8.74884 16.451 8.74365 16.4575C8.74063 16.4613 8.73888 16.4642 8.73779 16.4653L8.73682 16.4673L8.40088 16.7212C8.39685 16.7241 8.37947 16.7329 8.3501 16.7329C8.32039 16.7328 8.29977 16.7239 8.29346 16.7192L7.96143 16.4673L7.96045 16.4653L7.95654 16.4604C7.95155 16.454 7.94531 16.4447 7.93994 16.4341C7.93452 16.4232 7.93058 16.4123 7.92822 16.4038C7.92702 16.3995 7.92554 16.3966 7.92529 16.395H7.92432L7.92529 15.1274C7.92515 15.035 7.8742 14.95 7.79248 14.9067C7.41088 14.7047 7.15097 14.3051 7.15186 13.8472V13.8452C7.15226 13.1862 7.68882 12.651 8.3501 12.6499ZM8.72803 13.4478C8.51843 13.2386 8.17876 13.2385 7.96924 13.4478C7.76007 13.6573 7.7601 13.997 7.96924 14.2065C8.17878 14.4159 8.51844 14.4158 8.72803 14.2065C8.93737 13.997 8.93737 13.6573 8.72803 13.4478ZM8.37451 13.8013C8.38859 13.8156 8.38859 13.8387 8.37451 13.853C8.36019 13.867 8.33703 13.8671 8.32275 13.853C8.30887 13.8387 8.30884 13.8155 8.32275 13.8013C8.33701 13.7872 8.36018 13.7873 8.37451 13.8013Z"
                              fill="currentColor" />
                          </svg>
                        </a>
                      </li>
                      <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top"
                        title="Associate Plants" (click)="fetchPlantsTree(row,plantsAssociation);"
                        *ngIf="permissionsReady && permissions.canEdit">
                        <a title="Associate Plants" data-bs-toggle="modal"
                          class="text-primary d-inline-block edit-item-btn">
                          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="20" viewBox="0 0 30 20" fill="none">
                            <path
                              d="M29.213 12.5802L25.7016 1.56416C25.6594 1.43085 25.5774 1.3144 25.4671 1.23117C25.3568 1.14793 25.2237 1.1021 25.0865 1.10013H5.40529C5.26712 1.09879 5.1323 1.14355 5.0213 1.2276C4.91029 1.31165 4.82917 1.43041 4.79026 1.56583L1.2788 12.5786C1.24389 12.677 1.23356 12.7828 1.24874 12.8863C1.26392 12.9899 1.30413 13.0879 1.36573 13.1716C1.42503 13.2574 1.50405 13.327 1.59584 13.3743C1.68763 13.4216 1.7894 13.4452 1.8922 13.443H12.6201V15.4147H11.2277C11.1415 15.4147 11.0562 15.432 10.9766 15.4657C10.897 15.4993 10.8247 15.5487 10.7638 15.6109C10.7029 15.6732 10.6545 15.747 10.6216 15.8283C10.5886 15.9096 10.5716 15.9967 10.5716 16.0847V18.43C10.5716 18.6077 10.6407 18.7782 10.7638 18.9038C10.8868 19.0295 11.0537 19.1001 11.2277 19.1001H19.2724C19.4464 19.1001 19.6132 19.0295 19.7363 18.9038C19.8593 18.7782 19.9284 18.6077 19.9284 18.43V16.0847C19.9284 15.907 19.8593 15.7366 19.7363 15.6109C19.6132 15.4853 19.4464 15.4147 19.2724 15.4147H17.8684V13.4396H28.598C28.7004 13.4347 28.8004 13.4064 28.8906 13.3569C28.9809 13.3073 29.0591 13.2377 29.1196 13.1532C29.1782 13.0719 29.2172 12.9777 29.2334 12.8781C29.2496 12.7786 29.2427 12.6765 29.213 12.5802ZM11.8821 6.28318L12.3282 2.44364H18.1965L18.6426 6.28318H11.8821ZM20.6058 12.1145L20.0973 7.62669H26.2674L27.7025 12.1145H20.6058ZM19.4954 2.44364H24.6126L25.8459 6.28318H19.9415L19.4954 2.44364ZM16.576 13.458V15.4331H13.9519V13.458H16.576ZM11.2162 12.1179L11.7246 7.63004H18.7771L19.2855 12.1179H11.2162ZM4.65577 6.28653L5.87437 2.44698H10.9915L10.5454 6.28653H4.65577ZM2.79918 12.1179L4.23427 7.63004H10.4027L9.8959 12.1179H2.79918ZM18.613 16.7649L18.613 18.43H15.2419L11.8673 18.4957L11.8673 16.7649H18.613Z"
                              fill="currentColor" stroke="currentColor" />
                          </svg>
                        </a>
                      </li>
                    </ul>
                  </td>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
            <div *ngIf="permissionsReady && !permissions.canView" class="no-access text-center p-4">
              You don’t have permission to view this data.
            </div>

            <div class="table-meta">
              <div class="entries">
                <div class="dataTables_length p-0">
                  <label class="show-entries-list">
                    Show
                    <select [formControl]="pageSizeControl" (change)="changePageSize()"
                      class="form-control form-control-sm">
                      <option *ngFor="let limit of pageRecordOptions" [value]="limit.value">{{limit.label}}</option>
                    </select>
                    entries
                  </label>
                </div>
                <!-- <span>Show</span>
                  <select>
                      <option>12</option>
                  </select> -->
                <!-- <span>Total Records: {{this.total_items }}</span> -->
              </div>
              <!-- <nav class="table-pagination">
                  <ul>
                      <li><a class="init-bg" id="firstPage" (click)="goToPage(1)" [class.disabled]="current_page === 1">1</a></li>
                      <li><a class="no-bg" id="prevPage" (click)="navigatePage('prev')"><i class="fa fa-chevron-left"></i></a></li>
                      <li><a class="active">{{ current_page }}</a></li>
                      <li><a class="no-bg" id="nextPage" (click)="navigatePage('next')" [class.disabled]="current_page === total_pages"><i class="fa fa-chevron-right"></i></a></li>
                      <li><a class="init-bg" id="lastPage" (click)="goToPage(total_pages)" [class.disabled]="current_page === total_pages">{{this.total_pages}}</a></li>
                  </ul>
              </nav> -->
              <nav class="table-pagination">
                <ul>
                  <li>
                    <div class="go-to-page d-flex align-items-center">
                      <label>Go to Page:</label>
                      <input type="number" class="form-control form-control-sm" [(ngModel)]="pageToGo" min="1"
                        [max]="total_pages" (keydown.enter)="goToPage(pageToGo); pageToGo = null">
                      <div class="input-group-append">
                        <button class="btn btn-primary" type="button" (click)="goToPage(pageToGo); pageToGo = null"
                          [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                      </div>
                    </div>
                  </li>
                  <li><a class="init-bg" id="firstPage" (click)="goToPage(1)" [class.disabled]="current_page === 1">1</a>
                  </li>
                  <li><a class="no-bg" id="prevPage" (click)="navigatePage('prev')"><i class="fa fa-chevron-left"></i></a>
                  </li>
                  <li><a class="active">{{ current_page }}</a></li>
                  <li><a class="no-bg" id="nextPage" (click)="navigatePage('next')"
                      [class.disabled]="current_page === total_pages"><i class="fa fa-chevron-right"></i></a></li>
                  <li><a class="init-bg" id="lastPage" (click)="goToPage(total_pages)"
                      [class.disabled]="current_page === total_pages">{{this.total_pages}}</a></li>
                </ul>
              </nav>

            </div>

            <ng-template #content let-c="close" let-d="dismiss">
              <form>
                <div class="modal-header">
                  <h4 class="modal-title" id="modal-basic-title">Add Plants</h4>
                  <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                      <line x1="5" y1="5" x2="25" y2="25" stroke="#fff" stroke-width="2" />
                      <line x1="25" y1="5" x2="5" y2="25" stroke="#fff" stroke-width="2" />
                    </svg>
                  </button>
                </div>
                <form [formGroup]="linkPlant" (ngSubmit)="linkUserList()">
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-12 my-3">
                        <label for="typeahead-basic"> Plants:</label>

                        <ng-select [items]="allPlantList" bindLabel="plant_name" bindValue="station_id" [multiple]="true"
                          formControlName="plantName" [(ngModel)]="selectedCars" (change)="onMaterialGroupChange()"
                          name="plantName">
                        </ng-select>
                        <small class="text-danger" *ngIf="
                                                !linkPlant.get('plantName').valid &&
                                                linkPlant.get('plantName').touched
                                            ">Please Enter Plant Name</small>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-outline-dark" (click)="c('Save click')" type="submit">
                      Save
                    </button>
                  </div>
                </form>
              </form>
            </ng-template>

            <ng-template #link let-c="close" let-d="dismiss">
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">Link Plants</h4>
                <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                    <line x1="5" y1="5" x2="25" y2="25" stroke="#fff" stroke-width="2" />
                    <line x1="25" y1="5" x2="5" y2="25" stroke="#fff" stroke-width="2" />
                  </svg>
                </button>
              </div>
              <div class="modal-body">
                <div class="row p-4">
                  <div class="col-md-6 p-2" *ngFor="let item of PlantByUserlist">
                    <div>
                      <button type="button w-100" style="width: 100%; font-size: 12px" class="btn btn-dark">
                        {{ item.stationName }}
                        <span class="badge badge-danger position-absolute top--10"
                          style="top: -8px; right: -7px; font-size: 12px" (click)="removePlantLink(item)">
                          <i class="fa fa-times-circle"></i></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
      </div>
    </div>
  </section>
</section>

<ng-template #user let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Add User</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <rect width="24" height="24" rx="12" fill="white" />
        <path d="M7 7.00024L12.0515 12.0518L17.103 7.00024" stroke="currentColor" stroke-width="1.6"
          stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6.99995 17.6716L12.0505 12.6201L17.1021 17.6716" stroke="currentColor" stroke-width="1.6"
          stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </div>
  <div class="modal-body">
    <form #e="ngForm" [formGroup]="userList" (ngSubmit)="addUserAccout()" novalidate>
      <!-- <div class="modal-body auditbody"> -->
      <div class="form-group type-2">
        <div class="row">

          <!-- Full Name -->
          <div class="col-md-6 mb-2">
            <label>Full Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="full_name" required minlength="2" maxlength="50">
            <div
              *ngIf="userList.get('full_name').invalid && (userList.get('full_name').dirty || userList.get('full_name').touched)"
              class="text-danger">
              <div *ngIf="userList.get('full_name').hasError('required')">Name is required.</div>
              <div *ngIf="userList.get('full_name').hasError('minlength')">Name must be at least 2 characters long.
              </div>
              <div *ngIf="userList.get('full_name').hasError('maxlength')">Name cannot be more than 50 characters
                long.</div>
              <div *ngIf="userList.get('full_name').hasError('pattern')">Name can only contain letters.</div>
            </div>
          </div>

          <!-- Contact No -->
          <div class="col-md-6 mb-2">
            <label>Contact No</label>
            <input type="text" class="form-control" formControlName="contact" pattern="[0-9]*" minlength="11"
              maxlength="11" placeholder="03XXXXXXXXX">
            <div
              *ngIf="userList.get('contact').invalid && (userList.get('contact').dirty || userList.get('contact').touched)"
              class="text-danger">
              <div *ngIf="userList.get('contact').hasError('pattern')">Contact number can only contain numbers.</div>
              <div *ngIf="userList.get('contact').hasError('minlength')">Contact number must be 11 digits long.</div>
              <div *ngIf="userList.get('contact').hasError('maxlength')">Contact number must be 11 digits long.</div>
            </div>
          </div>

          <!-- User Name -->
          <div class="col-md-6 mb-2">
            <label>User Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="username" required minlength="2" maxlength="50">
            <div
              *ngIf="userList.get('username').invalid && (userList.get('username').dirty || userList.get('username').touched)"
              class="text-danger">
              <div *ngIf="userList.get('username').hasError('required')">Please enter a valid username.</div>
              <div *ngIf="userList.get('username').hasError('minlength')">Username must be at least 2 characters long.
              </div>
              <div *ngIf="userList.get('username').hasError('maxlength')">Username cannot be more than 50 characters
                long.</div>
              <div *ngIf="emailAlreadyExists">This User Name is already registered. Please enter a different User
                Name.</div>
            </div>
          </div>

          <!-- Email -->
          <div class="col-md-6 mb-2">
            <label>Email <span class="text-danger">*</span></label>
            <input type="email" class="form-control" formControlName="email" required email>
            <div *ngIf="userList.get('email').invalid && (userList.get('email').dirty || userList.get('email').touched)"
              class="text-danger">
              <div *ngIf="userList.get('email').hasError('required')">Email address is required.</div>
              <div *ngIf="userList.get('email').hasError('pattern')">Please enter a valid email address.</div>
            </div>
          </div>

          <!-- Employee ID -->
          <div class="col-md-6 mb-2">
            <label>Employee ID</label>
            <input type="text" class="form-control" formControlName="employee_id">
          </div>

          <!-- CNIC -->
          <div class="col-md-6 mb-2">
            <label>CNIC <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="cnic" placeholder="XXXXX-XXXXXXX-X" maxlength="15">
            <div *ngIf="userList.get('cnic').invalid && (userList.get('cnic').dirty || userList.get('cnic').touched)"
              class="text-danger">
              <div *ngIf="userList.get('cnic').hasError('pattern')">CNIC format should be XXXXX-XXXXXXX-X</div>
            </div>
          </div>

          <!-- User Type -->
          <div class="col-md-6 mb-2">
            <label>User Type <span class="text-danger">*</span></label>
            <ng-select formControlName="user_type" required placeholder="Select User Type">
              <ng-option *ngFor="let typeUser of userTypelist" [value]="typeUser.id">{{ typeUser.name }}</ng-option>
            </ng-select>
            <div
              *ngIf="userList.get('user_type').invalid && (userList.get('user_type').dirty || userList.get('user_type').touched)"
              class="text-danger">
              Please select a user type.
            </div>
          </div>

          <!-- Role -->
          <div class="col-md-6 mb-2">
            <label>Role <span class="text-danger">*</span></label>
            <ng-select formControlName="role" required placeholder="Select Role"
              [disabled]="!userList.get('user_type').value">
              <ng-option *ngFor="let role of rolesbyTypeList" [value]="role.id">{{ role.name }}</ng-option>
            </ng-select>
            <div *ngIf="userList.get('role').invalid && (userList.get('role').dirty || userList.get('role').touched)"
              class="text-danger">
              Please select a role.
            </div>
            <small class="text-muted" *ngIf="!userList.get('user_type').value">Please select a user type first</small>
          </div>

          <!-- Active/Inactive Toggle -->
          <div class="col-md-6 mb-2">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" formControlName="is_active" id="isActiveToggle">
              <label class="form-check-label" for="isActiveToggle">Active Status</label>
            </div>
            <!-- <small class="text-muted">{{ userList.get('is_active').value ? 'User is Active' : 'User is Inactive'
                }}</small> -->
          </div>

        </div>
      </div>
      <!-- </div> -->
      <div class="modal-footer">
        <div class="right">
          <button class="btn btn-raised btn-outline-dark mr-1" (click)="closeModal()" type="button">
            <i class="ft-x"></i> Cancel
          </button>
          <button class="btn btn-orange" type="submit" [disabled]="!userList.valid">
            <i class="fa fa-check-square-o"></i> Save
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-template>
<!-- Edit User Modal -->
<!-- Edit User Modal -->
<ng-template #userEdit let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Edit User</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <rect width="24" height="24" rx="12" fill="white" />
        <path d="M7 7.00024L12.0515 12.0518L17.103 7.00024" stroke="currentColor" stroke-width="1.6"
          stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6.99995 17.6716L12.0505 12.6201L17.1021 17.6716" stroke="currentColor" stroke-width="1.6"
          stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="userEditForm" (ngSubmit)="UpdateUserAccout()" novalidate>
      <div class="form-group type-2">
        <div class="row">

          <!-- Full Name -->
          <div class="col-md-6 mb-2">
            <label>Full Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="full_name">
            <div *ngIf="userEditForm.get('full_name')?.invalid && userEditForm.get('full_name')?.touched"
              class="text-danger">
              <div *ngIf="userEditForm.get('full_name').hasError('required')">Name is required.</div>
              <div *ngIf="userEditForm.get('full_name').hasError('minlength')">Name must be at least 2 characters
                long.</div>
              <div *ngIf="userEditForm.get('full_name').hasError('maxlength')">Name cannot be more than 50 characters
                long.</div>
              <div *ngIf="userEditForm.get('full_name').hasError('pattern')">Name can only contain letters.</div>
            </div>
          </div>

          <!-- Contact -->
          <div class="col-md-6 mb-2">
            <label>Contact No</label>
            <input type="text" class="form-control" formControlName="contact" maxlength="11" placeholder="03XXXXXXXXX">
            <div *ngIf="userEditForm.get('contact')?.invalid && userEditForm.get('contact')?.touched"
              class="text-danger">
              <div *ngIf="userEditForm.get('contact').hasError('pattern')">Contact number can only contain numbers.
              </div>
              <div *ngIf="userEditForm.get('contact').hasError('minlength')">Contact number must be 11 digits long.
              </div>
            </div>
          </div>

          <!-- Username (Disabled) -->
          <div class="col-md-6 mb-2">
            <label>User Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="username">
          </div>

          <!-- Email (Disabled) -->
          <div class="col-md-6 mb-2">
            <label>Email <span class="text-danger">*</span></label>
            <input type="email" class="form-control" formControlName="email">
          </div>

          <!-- Employee ID -->
          <div class="col-md-6 mb-2">
            <label>Employee ID</label>
            <input type="text" class="form-control" formControlName="employee_id">
          </div>

          <!-- CNIC -->
          <div class="col-md-6 mb-2">
            <label>CNIC <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="cnic" placeholder="XXXXX-XXXXXXX-X" maxlength="15">
            <div *ngIf="userEditForm.get('cnic')?.invalid && userEditForm.get('cnic')?.touched" class="text-danger">
              <div *ngIf="userEditForm.get('cnic').hasError('required')">CNIC is required.</div>
              <div *ngIf="userEditForm.get('cnic').hasError('pattern')">CNIC format should be XXXXX-XXXXXXX-X</div>
            </div>
          </div>

          <!-- User Type -->
          <div class="col-md-6 mb-2">
            <label>User Type <span class="text-danger">*</span></label>
            <ng-select formControlName="user_type" placeholder="Select User Type">
              <ng-option *ngFor="let typeUser of userTypelist" [value]="typeUser.id">
                {{ typeUser.name }}
              </ng-option>
            </ng-select>
            <div *ngIf="userEditForm.get('user_type')?.invalid && userEditForm.get('user_type')?.touched"
              class="text-danger">
              Please select a user type.
            </div>
          </div>

          <!-- Role -->
          <div class="col-md-6 mb-2">
            <label>Role <span class="text-danger">*</span></label>
            <ng-select formControlName="role" [disabled]="!userEditForm.get('user_type')?.value"
              placeholder="Select Role" [items]="rolesbyTypeList" bindValue="id" bindLabel="name">
            </ng-select>
            <div *ngIf="userEditForm.get('role')?.invalid && userEditForm.get('role')?.touched" class="text-danger">
              Please select a role.
            </div>
            <small class="text-muted" *ngIf="!userEditForm.get('user_type')?.value">
              Please select a user type first
            </small>
          </div>
          <div class="col-md-6 mb-2">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" formControlName="is_active" id="isActiveToggle">
              <label class="form-check-label" for="isActiveToggle">Active Status</label>
            </div>

            <!-- <small class="text-muted">{{ userList.get('is_active').value ? 'User is Active' : 'User is Inactive'
                }}</small> -->
          </div>

        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-outline-dark" type="button" (click)="closeModal()">Cancel</button>
        <button class="btn btn-orange" type="submit" [disabled]="!userEditForm.valid">
          Update
        </button>
      </div>
    </form>
  </div>
</ng-template>

<!-- View User Modal -->
<ng-template #userView let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">View User</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <rect width="24" height="24" rx="12" fill="white" />
        <path d="M7 7.00024L12.0515 12.0518L17.103 7.00024" stroke="currentColor" stroke-width="1.6"
          stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6.99995 17.6716L12.0505 12.6201L17.1021 17.6716" stroke="currentColor" stroke-width="1.6"
          stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="viewUserForm">
      <div class="form-group type-2">
        <div class="row">

          <!-- Full Name -->
          <div class="col-md-6 mb-2">
            <label>Full Name</label>
            <input type="text" class="form-control" formControlName="full_name" disabled>
          </div>

          <!-- Contact -->
          <div class="col-md-6 mb-2">
            <label>Contact No</label>
            <input type="text" class="form-control" formControlName="contact" disabled>
          </div>

          <!-- Username -->
          <div class="col-md-6 mb-2">
            <label>User Name</label>
            <input type="text" class="form-control" formControlName="username" disabled>
          </div>

          <!-- Email -->
          <div class="col-md-6 mb-2">
            <label>Email</label>
            <input type="email" class="form-control" formControlName="email" disabled>
          </div>

          <!-- Employee ID -->
          <div class="col-md-6 mb-2">
            <label>Employee ID</label>
            <input type="text" class="form-control" formControlName="employee_id" disabled>
          </div>

          <!-- CNIC -->
          <div class="col-md-6 mb-2">
            <label>CNIC</label>
            <input type="text" class="form-control" formControlName="cnic" disabled>
          </div>

          <!-- User Type -->
          <div class="col-md-6 mb-2">
            <label>User Type</label>
            <ng-select formControlName="user_type" disabled>
              <ng-option *ngFor="let typeUser of userTypelist" [value]="typeUser.id">
                {{ typeUser.name }}
              </ng-option>
            </ng-select>
          </div>

          <!-- Role -->
          <div class="col-md-6 mb-2">
            <label>Role</label>
            <ng-select formControlName="role" disabled>
              <ng-option *ngFor="let role of rolesbyTypeList" [value]="role.id">
                {{ role.name }}
              </ng-option>
            </ng-select>
          </div>
          <!-- Active/Inactive Toggle -->
          <div class="col-md-6 mb-2">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" formControlName="is_active" id="isActiveToggle">
              <label class="form-check-label" for="isActiveToggle">Active Status</label>
            </div>
            <!-- <small class="text-muted">{{ userList.get('is_active').value ? 'User is Active' : 'User is Inactive'
                }}</small> -->
          </div>

        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-outline-dark" type="button" (click)="closeModal()">
          Close
        </button>
      </div>
    </form>
  </div>
</ng-template>

<!-- <button class="btn btn-sm btn-primary mb-2" (click)="selectAllContracts()">Select All Contracts</button>

    <ul class="tree-root">
      <li *ngFor="let contract of contractTree">
        <div class="tree-header leaf">
          <div class="title-wrapper">
            <span *ngIf="contract.children?.length" (click)="toggleGroup(contract)" class="arrow-icon"
              [ngClass]="{'expanded': contract.expanded}" s>
              {{ contract.expanded ? '▼' : '▶' }}
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path
                  d="M2.30925 5.13086L5.56925 8.39086C5.95425 8.77586 6.58425 8.77586 6.96925 8.39086L10.2292 5.13086"
                  stroke="#FF4400" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            <span *ngIf="!contract.children?.length" class="arrow-placeholder"></span>
            <span>{{ contract.name }}</span>
          </div>
          <label class="custom-checkbox med white" *ngIf="hasNonEmptyChildren(contract)">
            <input class="checkbox-item" type="checkbox" type="checkbox" [(ngModel)]="contract.selected"
              (change)="toggleGroupSelection(contract)">
            <span class="checkbox-item"></span>
          </label>
        </div>

        <ul *ngIf="contract.expanded && contract.children?.length">
          <li *ngFor="let station of contract.children">
            <div class="title-wrapper">
              <span>{{ station.name }}</span>
              <label class="custom-checkbox med white" *ngIf="hasNonEmptyChildren(contract)">
                <input class="checkbox-item" type="checkbox" type="checkbox" [(ngModel)]="station.selected"
                  (change)="onStationChange(contract)">
                <span class="checkbox-item"></span>
              </label>
            </div>
          </li>
        </ul>
      </li>
    </ul> -->
<!-- <button class="btn btn-sm btn-primary mb-2" (click)="selectAllRegions()">Select All Regions</button>
    <ul class="tree-root">
      <li *ngFor="let region of regionTree">
        <div class="tree-header leaf">
          <div class="title-wrapper">
            <span *ngIf="region.children?.length" (click)="toggleGroup(region)" class="arrow-icon"
              [ngClass]="{'expanded': region.expanded}" s>
              {{ region.expanded ? '▼' : '▶' }}
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path
                  d="M2.30925 5.13086L5.56925 8.39086C5.95425 8.77586 6.58425 8.77586 6.96925 8.39086L10.2292 5.13086"
                  stroke="#FF4400" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            <span *ngIf="!region.children?.length" class="arrow-placeholder"></span>
            <span>{{ region.name }}</span>
          </div>
          <label class="custom-checkbox med white" *ngIf="hasNonEmptyChildren(region)">
            <input class="checkbox-item" type="checkbox" type="checkbox" [(ngModel)]="region.selected"
              (change)="toggleGroupSelection(region)">
            <span class="checkbox-item"></span>
          </label>
        </div>

        <ul *ngIf="region.expanded && region.children?.length">
          <li *ngFor="let city of region.children">
            <div class="tree-header leaf">
              <div class="title-wrapper">
                <span *ngIf="city.children?.length" (click)="toggleGroup(city)" class="arrow-icon"
                  [ngClass]="{'expanded': city.expanded}" s>
                  {{ city.expanded ? '▼' : '▶' }}
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                    <path
                      d="M2.30925 5.13086L5.56925 8.39086C5.95425 8.77586 6.58425 8.77586 6.96925 8.39086L10.2292 5.13086"
                      stroke="#FF4400" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </span>
                <span *ngIf="!city.children?.length" class="arrow-placeholder"></span>
                <span>{{ city.name }}</span>
              </div>
              <label class="custom-checkbox med white" *ngIf="hasNonEmptyChildren(city)">
                <input class="checkbox-item" type="checkbox" type="checkbox" [(ngModel)]="city.selected"
                  (change)="toggleGroupSelection(city)">
                <span class="checkbox-item"></span>
              </label>
            </div>

            <ul *ngIf="city.expanded && city.children?.length">
              <li *ngFor="let station of city.children">
                <div class="tree-header leaf">
                  <div class="title-wrapper">
                    <span>{{ station.name }}</span>
                  </div>
                  <label class="custom-checkbox med white">
                    <input class="checkbox-item" type="checkbox" type="checkbox" [(ngModel)]="station.selected"
                      (change)="onStationChange(city)">
                    <span class="checkbox-item"></span>
                  </label>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul> -->
<ng-template #plantsAssociation let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">User Plants Access</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal();resetAllSelections()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <rect y="0.696289" width="24" height="24" rx="12" fill="white" />
        <path d="M6.99988 7.69653L12.0514 12.748L17.1029 7.69653" stroke="currentColor" stroke-width="1.6"
          stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6.99995 18.3679L12.0505 13.3164L17.1021 18.3679" stroke="currentColor" stroke-width="1.6"
          stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </div>
  <div class="modal-body">
    <div class="user-meta">
      <div class="row">
        <div class="col-4">
          <div class="meta-box d-flex align-items-center justify-content-center gap-1">
            User ID:
            <span class="fw-semibold">{{selectedUser?.user_id}}</span>
          </div>
        </div>
        <div class="col-4">
          <div class="meta-box d-flex align-items-center justify-content-center gap-1">
            User Name:
            <span class="fw-semibold">{{selectedUser?.username}}</span>
          </div>
        </div>
        <div class="col-4">
          <div class="meta-box d-flex align-items-center justify-content-center gap-1">
            Email:
            <span class="fw-semibold">{{selectedUser?.email}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center gap-4 association-block">
      <div class="col-list">
        <div class="association-wrapper">
          <div class="header">
            <ul class="nav nav-tabs" id="plantTabs" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="contract-tab" data-bs-toggle="tab" data-bs-target="#contract"
                  type="button" role="tab" aria-controls="contract" aria-selected="true"
                  (click)="activeTab = 'contract'">
                  Contract Type
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="region-tab" data-bs-toggle="tab" data-bs-target="#region" type="button"
                  role="tab" aria-controls="region" aria-selected="false" (click)="activeTab = 'region'">
                  Region
                </button>
              </li>
            </ul>
          </div>
          <div class="tab-content" id="plantTabsContent">
            <!-- Contract Tab -->
            <div class="tab-pane fade show active" id="contract" role="tabpanel" aria-labelledby="contract-tab">
              <ul class="tree-root">
                <!-- Select All as first li with checkbox -->
                <li>
                  <div class="tree-header leaf">
                    <div class="title-wrapper">
                      <span (click)="toggleSelectAllContract()" class="arrow-icon"
                        [ngClass]="{'expanded': selectAllContractExpanded}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                          <path
                            d="M2.30925 5.13086L5.56925 8.39086C5.95425 8.77586 6.58425 8.77586 6.96925 8.39086L10.2292 5.13086"
                            stroke="#FF4400" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </span>
                      <span>Zero Carbon Pvt Ltd</span>
                    </div>
                    <label class="custom-checkbox med white">
                      <input class="checkbox-item" type="checkbox" [(ngModel)]="selectAllContractChecked"
                        (change)="selectAllContracts()">
                      <span class="checkbox-item"></span>
                    </label>
                  </div>

                  <!-- Collapsible content for Select All -->
                  <ul *ngIf="selectAllContractExpanded">
                    <li *ngFor="let contract of contractTree">
                      <div class="tree-header leaf">
                        <div class="title-wrapper">
                          <span *ngIf="contract.children?.length" (click)="toggleGroup(contract)" class="arrow-icon"
                            [ngClass]="{'expanded': contract.expanded}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"
                              fill="none">
                              <path
                                d="M2.30925 5.13086L5.56925 8.39086C5.95425 8.77586 6.58425 8.77586 6.96925 8.39086L10.2292 5.13086"
                                stroke="#FF4400" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                stroke-linejoin="round" />
                            </svg>
                          </span>
                          <span *ngIf="!contract.children?.length" class="arrow-placeholder"></span>
                          <span>{{ contract.name }}</span>
                        </div>
                        <label class="custom-checkbox med white" *ngIf="hasNonEmptyChildren(contract)">
                          <input class="checkbox-item" type="checkbox" [(ngModel)]="contract.selected"
                            (change)="toggleGroupSelection(contract)">
                          <span class="checkbox-item"></span>
                        </label>
                      </div>

                      <ul *ngIf="contract.expanded && contract.children?.length">
                        <li *ngFor="let station of contract.children">
                          <div class="title-wrapper">
                            <span>{{ station.name }}</span>
                            <label class="custom-checkbox med white" *ngIf="hasNonEmptyChildren(contract)">
                              <input class="checkbox-item" type="checkbox" [(ngModel)]="station.selected"
                                (change)="onStationChange(contract)">
                              <span class="checkbox-item"></span>
                            </label>
                          </div>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <!-- Region Tab -->
            <div class="tab-pane fade" id="region" role="tabpanel" aria-labelledby="region-tab">
              <ul class="tree-root">
                <!-- Select All Regions as first li with checkbox -->
                <li>
                  <div class="tree-header leaf">
                    <div class="title-wrapper">
                      <span (click)="toggleSelectAllRegions()" class="arrow-icon"
                        [ngClass]="{'expanded': selectAllRegionsExpanded}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                          <path
                            d="M2.30925 5.13086L5.56925 8.39086C5.95425 8.77586 6.58425 8.77586 6.96925 8.39086L10.2292 5.13086"
                            stroke="#FF4400" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </span>
                      <span>Zero Carbon Pvt Ltd</span>
                    </div>
                    <label class="custom-checkbox med white">
                      <input class="checkbox-item" type="checkbox" [(ngModel)]="selectAllRegionsChecked"
                        (change)="selectAllRegions()">
                      <span class="checkbox-item"></span>
                    </label>
                  </div>

                  <!-- Collapsible content for Select All Regions -->
                  <ul *ngIf="selectAllRegionsExpanded">
                    <li *ngFor="let region of regionTree">
                      <div class="tree-header leaf">
                        <div class="title-wrapper">
                          <span *ngIf="region.children?.length" (click)="toggleGroup(region)" class="arrow-icon"
                            [ngClass]="{'expanded': region.expanded}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"
                              fill="none">
                              <path
                                d="M2.30925 5.13086L5.56925 8.39086C5.95425 8.77586 6.58425 8.77586 6.96925 8.39086L10.2292 5.13086"
                                stroke="#FF4400" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                stroke-linejoin="round" />
                            </svg>
                          </span>
                          <span *ngIf="!region.children?.length" class="arrow-placeholder"></span>
                          <span>{{ region.name }}</span>
                        </div>
                        <label class="custom-checkbox med white" *ngIf="hasNonEmptyChildren(region)">
                          <input class="checkbox-item" type="checkbox" [(ngModel)]="region.selected"
                            (change)="toggleGroupSelection(region)">
                          <span class="checkbox-item"></span>
                        </label>
                      </div>

                      <ul *ngIf="region.expanded && region.children?.length">
                        <li *ngFor="let city of region.children">
                          <div class="tree-header leaf">
                            <div class="title-wrapper">
                              <span *ngIf="city.children?.length" (click)="toggleGroup(city)" class="arrow-icon"
                                [ngClass]="{'expanded': city.expanded}">
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"
                                  fill="none">
                                  <path
                                    d="M2.30925 5.13086L5.56925 8.39086C5.95425 8.77586 6.58425 8.77586 6.96925 8.39086L10.2292 5.13086"
                                    stroke="#FF4400" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                </svg>
                              </span>
                              <span *ngIf="!city.children?.length" class="arrow-placeholder"></span>
                              <span>{{ city.name }}</span>
                            </div>
                            <label class="custom-checkbox med white" *ngIf="hasNonEmptyChildren(city)">
                              <input class="checkbox-item" type="checkbox" [(ngModel)]="city.selected"
                                (change)="toggleGroupSelection(city)">
                              <span class="checkbox-item"></span>
                            </label>
                          </div>

                          <ul *ngIf="city.expanded && city.children?.length">
                            <li *ngFor="let station of city.children">
                              <div class="tree-header leaf">
                                <div class="title-wrapper">
                                  <span>{{ station.name }}</span>
                                </div>
                                <label class="custom-checkbox med white">
                                  <input class="checkbox-item" type="checkbox" [(ngModel)]="station.selected"
                                    (change)="onStationChange(city)">
                                  <span class="checkbox-item"></span>
                                </label>
                              </div>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <button class="btn btn-orange btn-select" (click)="addSelectedPlants()">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12" fill="none">
          <path d="M1.5 1L6.5 6L1.5 11" stroke="white" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M8.5 1L13.5 6L8.5 11" stroke="white" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
      <div class="col-list">
        <div class="selected-wrapper">
          <h4 class="selected-title">Selected Plants</h4>
          <ul class="tree-root selected">
            <li class="d-flex justify-content-between align-items-center" *ngFor="let plant of selectedPlants">
              {{ plant.name }} ({{ plant.stationCode }})
              <button class="btn btn-link" (click)="removePlant(plant.stationId)">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect width="24" height="24" rx="12" fill="white" />
                  <path d="M8.10303 8.16578L12.0515 12.1143L16 8.16578" stroke="#EF4323" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.10328 16.5066L12.051 12.5581L15.9995 16.5066" stroke="#EF4323" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <button class="btn btn-orange rounded-0 w-100" (click)="onApply()">Done</button>
  </div>
</ng-template>
<ng-template #modalReset let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      Reset Default Password
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click');">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <rect width="24" height="24" rx="12" fill="white" />
        <path d="M7 7.00024L12.0515 12.0518L17.103 7.00024" stroke="currentColor" stroke-width="1.6"
          stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6.99995 17.6716L12.0505 12.6201L17.1021 17.6716" stroke="currentColor" stroke-width="1.6"
          stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </div>
  <div class="modal-body">
    <div class="d-flex flex-column gap-3 align-items-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="44" height="50" viewBox="0 0 44 50" fill="none">
        <path
          d="M9.59986 23.612V14.0121C9.59687 11.0362 10.6997 8.16535 12.6944 5.95688C14.689 3.74841 17.433 2.35985 20.3939 2.06078C23.3547 1.76171 26.321 2.57345 28.717 4.33843C31.1129 6.10341 32.7676 8.69571 33.3598 11.6121"
          stroke="#EF4323" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M38.4004 23.6001C41.0511 23.6003 43.2001 25.7492 43.2002 28.3999V45.1997C43.2002 47.8505 41.0511 50.0002 38.4004 50.0005H4.7998C2.14893 50.0004 0 47.8506 0 45.1997V28.3999C0.000100756 25.7491 2.14899 23.6002 4.7998 23.6001H38.4004ZM21.6084 30.8306C19.258 30.8347 17.352 32.7394 17.3516 35.0874C17.3478 36.6371 18.1794 37.991 19.4131 38.7378V41.9019C19.4162 42.0981 19.48 42.2983 19.5635 42.4653C19.6261 42.5907 19.7113 42.7212 19.8193 42.8296L19.9346 42.9302L20.8262 43.606L20.8311 43.6089C21.0603 43.7773 21.3436 43.8524 21.6094 43.853C21.8749 43.8536 22.1603 43.78 22.3906 43.606L22.3916 43.605L23.2861 42.9272H23.2852C23.4437 42.8082 23.5705 42.6401 23.6562 42.4722C23.7414 42.3055 23.8044 42.1007 23.8027 41.895H23.8047L23.8076 38.7358C25.0431 37.994 25.8703 36.6353 25.874 35.0884L25.8682 34.8687C25.7533 32.622 23.8866 30.8268 21.6084 30.8306ZM21.6094 31.6304C23.5187 31.6272 25.0731 33.1824 25.0732 35.0884C25.0696 36.4167 24.3206 37.5731 23.2227 38.1479C23.091 38.2169 23.008 38.3538 23.0078 38.5024L23.0039 41.895L23.0049 41.9009C23.0055 41.9419 22.9898 42.0186 22.9443 42.1079C22.8992 42.1964 22.844 42.2599 22.8057 42.2886L22.8018 42.2905L21.9092 42.9673C21.844 43.0166 21.7377 43.0525 21.6113 43.0522C21.4851 43.0519 21.3747 43.0158 21.3047 42.9644L20.415 42.2905L20.4131 42.2886L20.3496 42.2231C20.3262 42.193 20.3013 42.154 20.2783 42.1079C20.2344 42.0199 20.216 41.941 20.2139 41.895V38.5063C20.2139 38.3583 20.1317 38.2222 20.001 38.1528C18.8998 37.5699 18.1482 36.4152 18.1514 35.0894V35.0884C18.1515 33.1827 19.6989 31.6338 21.6094 31.6304ZM22.4326 34.2144C21.9778 33.7597 21.24 33.7598 20.7852 34.2144C20.3304 34.6692 20.3305 35.407 20.7852 35.8618C21.24 36.3167 21.9777 36.3166 22.4326 35.8618C22.8872 35.4069 22.8874 34.6691 22.4326 34.2144ZM21.3506 34.7808C21.493 34.6384 21.7247 34.6375 21.8672 34.7798C22.0096 34.9222 22.0094 35.1539 21.8672 35.2964C21.7247 35.4387 21.493 35.4388 21.3506 35.2964C21.2084 35.154 21.2085 34.9232 21.3506 34.7808Z"
          fill="#EF4323" />
      </svg>
      <p class="text-center">Are you sure you want to reset to default password of this user?</p>
    </div>
  </div>
  <div class="modal-footer no-bg">
    <button type="button" class="btn btn-outline-dark" aria-label="Close" (click)="d('Cross click')">
      Cancel
    </button>
    <button type="button" class="btn btn-orange" (click)="c('confirm')" type="submit">
      Confirm
    </button>
  </div>
</ng-template>